import { render, staticRenderFns } from "./PaymentTypeSidebar.vue?vue&type=template&id=4a435106&"
import script from "./PaymentTypeSidebar.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a435106')) {
      api.createRecord('4a435106', component.options)
    } else {
      api.reload('4a435106', component.options)
    }
    module.hot.accept("./PaymentTypeSidebar.vue?vue&type=template&id=4a435106&", function () {
      api.rerender('4a435106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/financial/payment-type/PaymentTypeSidebar.vue"
export default component.exports